/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Deep_TitleInputs */

const en_viewer_deep_title = /** @type {(inputs: Viewer_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the tree shows that raw text does not`)
};

const ko_viewer_deep_title = /** @type {(inputs: Viewer_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`트리가 보여주는데 원문은 보여주지 않는 것`)
};

const ja_viewer_deep_title = /** @type {(inputs: Viewer_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツリーが示して生のテキストが示さないもの`)
};

/**
* | output |
* | --- |
* | "What the tree shows that raw text does not" |
*
* @param {Viewer_Deep_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_deep_title = /** @type {((inputs?: Viewer_Deep_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Deep_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_deep_title(inputs)
	if (locale === "ko") return ko_viewer_deep_title(inputs)
	return ja_viewer_deep_title(inputs)
});